/**
 * Copyright © Veeam Software Group GmbH.
 */

import { ScheduleDailyKindRepresentation } from '@veeam-vspc/models/web-controllers';

export type DailyKindsEnums = ScheduleDailyKindRepresentation;
export const DailyKindsEnums = ScheduleDailyKindRepresentation;
